export const options = {
  indexAxis: "y" as const,
  elements: {
    bar: {
      borderWidth: 2,
    },
  },
  responsive: true,
  plugins: {
    legend: {
      position: "bottom" as const,
    },
    title: {
      display: true,
      text: "Ventas en pesos",
      font: {
        size: 20,
      },
    },
  },
};

export function generateData(array: any) {
  const labels = array.map((item: any) => item.fuente);
  return {
    labels,
    datasets: [
      {
        label: "Ventas en pesos",
        data: array.map((item: any) => item.resultado),
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ],
  };
}

export function Columns() {
  return [
    { title: "Modelo", campo: "modelo", buscador: true },
    { title: "Cantidad", campo: "cantidad", buscador: false },
    { title: "Precio", campo: "precio" },
    { title: "Total", campo: "total" },
  ];
}
